import { createContext } from 'react';
import type { ToolImage, ImageLabel, LabelingState } from '../types/LabelingTypes';

export interface LabelingContextType extends LabelingState {
  readonly toolId: string;
  readonly sessionId: string;
  filtered: ToolImage[];
  current: ToolImage | undefined;
  stats: { ok: number; worn: number; unreadable: number; done: number; total: number };
  progressPct: number;
  applyLabel(key: string, state: ImageLabel): void;
  undo(): void;
  jump(key: string): void;
  goPrev(): void;
  goNext(): void;
  setMode(m: 'focus' | 'grid' | 'dichotomous'): void;
  setStatusFilter(s: 'all' | 'todo' | 'done'): void;
  setSeriesFilter(v: string): void;
  toggleSelect(key: string): void;
  bulkLabel(state: ImageLabel): void;
  /** Applies an explicit key→label list in one shot and syncs it to the server. */
  applyLabelsBulk(entries: Array<{ key: string; label: ImageLabel }>): Promise<void>;
  clearSelection(): void;
  setAutoAdvance(b: boolean): void;
  classifyWithAi(key: string): Promise<void>;
  refreshImageUrl(key: string): Promise<void>;
  acceptSuggestion(key: string): void;
  rejectSuggestion(key: string): void;
  acceptAllSuggestions(): void;
  rejectAllSuggestions(): void;
  classifyAllWithAi(): Promise<void>;
  resetAnnotations(): Promise<void>;
  bulkClassifyWithAi(): Promise<void>;
}

export const LabelingContext = createContext<LabelingContextType | null>(null);
